/* eslint-disable @nx/enforce-module-boundaries */
import { useAuthContext } from '@aibees/shared/auth';
import { UserRole } from '@aibees/shared/definition';
import { useFeatureFlagsContext } from '@aibees/shared/feature-flags';
import { FeatureFlags } from '../types/feature-flags';

export function useIsCrawlRequestFeatureEnabled() {
  const { user } = useAuthContext();

  const hasCrawlRequestRole = user?.roles?.includes(UserRole.ElCrwlRqst);

  const isCrawlRequestEnabled = useFeatureFlagsContext().isFeatureEnabled(
    FeatureFlags.CRAWL_REQUEST
  );

  return isCrawlRequestEnabled || hasCrawlRequestRole;
}
